const CAMPAIGN_OBJECTIVE = {
  budget: 0,
  reach: 1,
  rating: 2,
  placed: 3,
};

export default CAMPAIGN_OBJECTIVE;